import Vue from 'vue';
import moment from 'moment';
import Toasted from 'vue-toasted';
import VueClipboard from 'vue-clipboard2';

import App from './App.vue';
import router from './router';
import store from './store/index';

Vue.config.productionTip = false;

Vue.use(VueClipboard);
Vue.use(Toasted, { duration: 4000 });
Vue.filter('moment', (date) => moment(date).from());

Vue.filter('cap', (value) => {
  if (!value) return '';
  const val = value.toString();
  return val.charAt(0).toUpperCase() + val.slice(1);
});

Vue.filter('floor', (v) => ((!v) ? '' : Math.floor(v)));

new Vue({
  router,
  store,
  render: (h) => h(App),
  // mounted: () => document.dispatchEvent(new Event('x-app-rendered')),
}).$mount('#app');
